import { type GqlCreateIdentityInput, type GqlRatsitIdentity } from '../../../graphql/base-types.graphql';

export const ratsitIdentity2Input = (ratsitIdentity: GqlRatsitIdentity): GqlCreateIdentityInput => {
  return {
    ...ratsitIdentity,
    email: undefined,
    phone: undefined,
  };
};
